import PreviewExpandable from 'app/features/questionnaires/components/PreviewExpandable';
import { useSelector } from 'react-redux';
import { selectQuestionnaireRoutes } from '../../routes/slice';
import PreviewAccountsList from './AccountsList/preview';
import PreviewNonUSFinancialAccounts from './NonUSFinancialAccounts/preview';

export interface INonUSFinancialAccountsProps {}

export default function NonUSFinancialAccounts(
  props: INonUSFinancialAccountsProps,
) {
  const routes = useSelector(selectQuestionnaireRoutes).routes;

  return (
    <>
      <PreviewExpandable title="Non US Finantial Accounts">
        {routes.nonUsFinancialAccounts.accountsList && <PreviewAccountsList />}
        {routes.nonUsFinancialAccounts.nonUsFinancialAccounts && (
          <PreviewNonUSFinancialAccounts />
        )}
      </PreviewExpandable>
    </>
  );
}
